import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setRmvendorFilterCriteria } from 'store/slice/PharmaSlice';

export default function RmvendorFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.rmvendorDashboard);
    
    

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>

        </Grid>
    )

}